import { render, staticRenderFns } from "./PeopleActions.vue?vue&type=template&id=5bac2a44&scoped=true&"
import script from "./PeopleActions.vue?vue&type=script&lang=js&"
export * from "./PeopleActions.vue?vue&type=script&lang=js&"
import style0 from "./PeopleActions.vue?vue&type=style&index=0&id=5bac2a44&prod&scoped=true&lang=scss&"
import style1 from "./PeopleActions.vue?vue&type=style&index=1&id=5bac2a44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bac2a44",
  null
  
)

export default component.exports